import Vue from             'vue'
import Router from          'vue-router'
import _import from         './_import';

import users from           './users.js';
import about from           './about.js';
import member from          './member.js';
import service from         './service.js';
import register from        './register.js';
import glocalme from        './glocalme.js';
import cloudsim from        './cloudsim.js';
import worldphone from      './worldphone.js';
import simbox from          './simbox.js';
import data_package from    './data_package.js';
import purchase from        './purchase.js';
import us_mall from        './us_mall.js';

import pages_view from      '../views/PagesView'

Vue.use(Router);

const routes = [
    {
        // path: '/:_locale([A-Za-z]{2})?/:_lang([A-Za-z]{2})?',
		path : '/',
        component: pages_view,
        alias: [
            ''
        ],
        children: [
            // 首页
            {
                path: 'home',
                name: 'home',
                component: _import('home')
            },
            // 流量商城
            {
                path: 'data_package',
                name: 'data_package',
                component: _import('data_package')
            },
            // 老用户切换选择注册国家/地区
            {
                path: 'old_select',
                name: 'old_select',
                component: _import('old_select')
            },
            // 设备海报页
            ...cloudsim,
            // 手机海报页
            ...worldphone,
            // simbox海报页
            ...simbox,
            // 用户
            ...users,
            // 关于
            ...about,
            // 服务
            ...service,
            // 注册
            ...register,
            // glocalme
            ...glocalme,
            // 会员中心
            ...member,
            ...data_package,
            ...purchase,
            // US 商城
            ...us_mall,
            // 引导关注百弈通微信公众号页面
            {
                path: 'guide_byt',
                component: _import('guide_byt')
            },
        ]
    },
    // 404 页面
    {
         path: '/:_locale([A-Za-z]{2})?/:_lang([A-Za-z]{2})?/404',
         name: '404',
         component: _import('404')
    },
    {
        path: '*',
        redirect: '404'
    }
];
export default {
    mode: 'history',
    routes
}
/*export default new Router({
    mode: 'history',
    routes
});*/


// WEBPACK FOOTER //
// ./src/router/index.js